export const excludeComponentProps = (...props) => ({
    shouldForwardProp: (property) => !props.includes(property)
});
